module.exports = __webpack_public_path__ + "static/media/adbop_logo_small_new.91f1b5c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/adbop_logo_small_new.svg
// module id = 227
// module chunks = 0